import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, throwError } from 'rxjs';
const AUTH_API = environment.serverURL;

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  // filter observer
  private _country = new BehaviorSubject('');
  public _getCountry = this._country.asObservable();

  private _countryDetails = new BehaviorSubject({});
  public _getCountryDetails = this._countryDetails.asObservable();
  // bar
  private _getSAbarChart = new BehaviorSubject({});
  private _getSAbarLables = new BehaviorSubject({});
  public _getSABarChartObserver = this._getSAbarChart.asObservable();
  public _getSABarCharLablesObserver = this._getSAbarLables.asObservable();
  //spa bar
  private _getSPABarChart = new BehaviorSubject({});
  private _getSPABarChartLabel = new BehaviorSubject({});
  public _getSPABarChartObserver = this._getSPABarChart.asObservable();
  public _getSPABarChartLabelObserver = this._getSPABarChartLabel.asObservable();
  //spa polar
  private _getSPAPolarChart = new BehaviorSubject({});
  private _getSPAPolarChartLabel = new BehaviorSubject({});
  public _getSPAPolarChartObserver = this._getSPAPolarChart.asObservable();
  public _getSPAPolarChartLabelObserver = this._getSPAPolarChartLabel.asObservable();
  //revenue
  private _getSARevenueSummaryChart = new BehaviorSubject({});
  private _getSARevenueSummaryLables = new BehaviorSubject({});
  public _getSARevenueSummaryChartObserver = this._getSARevenueSummaryChart.asObservable();
  public _getSARevenueSummaryCharLablesObserver = this._getSARevenueSummaryLables.asObservable();
  // advertisement
  private _getSAAdvertisementChart = new BehaviorSubject({});
  private _getSAAdvertisementLables = new BehaviorSubject({});
  public _getSAAdvertisementChartObserver = this._getSAAdvertisementChart.asObservable();
  public _getSAAdvertisementCharLablesObserver = this._getSAAdvertisementLables.asObservable();

  // advertisers login user

  // private _advertisersPolarGraphData = new BehaviorSubject({});
  // private _advertisersPolarGraphLables = new BehaviorSubject({});
  // private _advertisersPolarGraphColor = new BehaviorSubject({});
  // public _getAdvertisersAdvertisementObserver = this._advertisersPolarGraphData.asObservable();
  // public _getAdvertisersAdvertisementLablesObserver = this._advertisersPolarGraphLables.asObservable();
  // public _getAdvertisersAdvertisementColorObserver = this._advertisersPolarGraphColor.asObservable();

  private _advertisersPolarGraphDetails = new BehaviorSubject({});
  public _getAdvertisersPolarGraphObserver = this._advertisersPolarGraphDetails.asObservable();


  private _advertisersPaymentGraphDetailsLables = new BehaviorSubject({});
  public _getAdvertisersPaymentGraphLablesObserver = this._advertisersPaymentGraphDetailsLables.asObservable();
  private _advertisersPaymentGraphDetailsChart = new BehaviorSubject({});
  public _getAdvertisersPaymentGraphChartObserver = this._advertisersPaymentGraphDetailsChart.asObservable();
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {

  }
  // Observables
  // filter
  // set country
  setCountry(data) {
    this._country.next(data)
  }
  setCountryDetails(data) {
    this._countryDetails.next(data)
  }
  //super admin
  // bar
  setSAbarData(data, label) {
    this._getSAbarChart.next(data);
    this._getSAbarLables.next(label)
  }
  // revenue
  setSARevenueSummaryData(data, label) {
    this._getSARevenueSummaryChart.next(data);
    this._getSARevenueSummaryLables.next(label)
  }
  // advertisement
  setSAAdvertisementData(data) {
    this._getSAAdvertisementChart.next(data);
  }
  //spa 
  setSPABarChartData(data, label) {
    this._getSPABarChart.next(data);
    this._getSPABarChartLabel.next(label);
  }
  //spa polar
  setSPAPolarChartData(data, label) {
    this._getSPAPolarChart.next(data);
    this._getSPAPolarChartLabel.next(label);
  }
  // super admin 
  // bar
  getSABarCount(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/admin/get-bar-graph-data`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // page analyser
  pageAnalyser(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/admin/dashboard/count`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // revenue seummary
  revenueSummary(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/admin/dashboard/revenue-details`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // advertisements
  advertisements(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/admin/dashboard/advertisement-details-aggregate`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // spa 
  // bar
  getSPABarCount(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/serviceProviderAdmin/get-spa-bar-graph-data`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  //spa polar graph
  getSPAPolarGraphCount(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/serviceProviderAdmin/get-service-request-graph-data`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // page analyser
  spaPageAnalyser(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/serviceProviderAdmin/dashboard/count`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // advertiser

  //advertiser login
  setAdvertiserPolarGraphData(data, label, color) {
    // this._advertisersPolarGraphData.next(data);
    // this._advertisersPolarGraphLables.next(label)
    // this._advertisersPolarGraphColor.next(color)

    let resultObj = {
      data: data,
      label: label,
      color: color
    }
    this._advertisersPolarGraphDetails.next(resultObj)
  }
  //  polar graph
  getAdvertiserPolarGraphCount(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/advertiser/dashboard/advertisement-pie-chart-details`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  setAdvertiserPaymentGraphData(data, label) {
    // this._advertisersPolarGraphData.next(data);
    // this._advertisersPolarGraphLables.next(label)
    // this._advertisersPolarGraphColor.next(color)

    this._advertisersPaymentGraphDetailsChart.next(data);
    this._advertisersPaymentGraphDetailsLables.next(label);
  }
  getAdvertiserPaymentGraph(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/advertiser/dashboard/advertiser-payment-chart`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
  // revenue seummary
  transactionSummary(payload) {
    this.spinner.show();
    return this.http.post(`${AUTH_API}/admin/dashboard/get-transaction-summary`, payload).pipe(map(result => {
      this.spinner.hide();
      return result
    }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err)
      }))
  }
}
